import { get, post, put, deleteReq } from "../../service/api";

export const ListFeeShareRules = async (merchantId) => {
  try {
    return await get(`/feeShareRule?merchantId=${merchantId}`);
  } catch (error) {
    console.error("Error ListFeeShareRules:", error);
    throw error;
  }
};

export const CreateFeeShareRule = async (body) => {
  try {
    return await post(`/feeShareRule`, body);
  } catch (error) {
    console.error("Error CreateFeeShareRule:", error);
    throw error;
  }
};

export const UpdateFeeShareRule = async (id, body) => {
  try {
    return await put(`/feeShareRule/${id}`, body);
  } catch (error) {
    console.error("Error UpdateFeeShareRule:", error);
    throw error;
  }
};

export const DeleteFeeShareRule = async (id) => {
  try {
    return await deleteReq(`/feeShareRule/${id}`);
  } catch (error) {
    console.error("Error DeleteFeeShareRule:", error);
    throw error;
  }
};

export const ListTransactionFeeShares = async (query) => {
  try {
    return await get(`/feeShareRule/shares?${query}`);
  } catch (error) {
    console.error("Error ListTransactionFeeShares:", error);
    throw error;
  }
};

export const RetryFailedIncomes = async (merchantSettleId) => {
  try {
    return await post(`/feeShareRule/retry-failed/${merchantSettleId}`, {});
  } catch (error) {
    console.error("Error RetryFailedIncomes:", error);
    throw error;
  }
};

